<template>
    <div class="header" v-on:click="headerClick()">
        <div class="logo">
            <img class="bg-grid" src="../../assets/logo_cota_white_mobile.svg" alt="Cota.80.86 - Arqueologia"/>
        </div>
        <div class="menu-button"
            v-on:click="toggleMenu($event)">
            <button class="hamburger hamburger--vortex" type="button" v-bind:class="{ 'is-active': isOpen}">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MobileHeader",
        data() {
            return {
                isOpen: false
            }
        },
        props: ['open'],
        watch: {
            'open': function () {
                this.isOpen = this.open;
            }
        },
        mounted() {
            window.addEventListener('resize', this.closeMenu);
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.closeMenu);
        },
        methods: {
            toggleMenu($event) {
                $event.stopPropagation();
                this.isOpen = !this.isOpen;
                this.$emit('toggle-menu', this.isOpen);
            },
            closeMenu() {
                this.isOpen = false;
                this.$emit('toggle-menu', this.isOpen);
            },
            headerClick() {
                this.$router.push('/').catch(() => {});
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/global';

    .header {
        height: $mobile-bar-height;
        color: white;
        overflow: hidden;

        border-bottom-style: solid;
        border-bottom-width: thin;
        border-bottom-color: $bgcolor;
    }

    .logo {
        position: relative;
        height: 100%;
        width: 75%;
        float: left;

        img {
            position: relative;
            top: 42%;
            width: 70%;
        }
    }

    .menu-button {
        position: relative;
        height: 100%;
        width: 25%;
        float: right;

        button {
            position: relative;
            top: 20%;
        }
    }

    .hamburger-inner {
        height: 3px;
    }

    .hamburger-inner::before {
        height: 3px;
    }

    .hamburger-inner::after {
        height: 3px;
    }
</style>
